const Env = {
  endpoints: {
    auth: process.env.REACT_APP_API_ENDPOINT_AUTH,
    user: process.env.REACT_APP_API_ENDPOINT_USER,
    practice: process.env.REACT_APP_API_ENDPOINT_PRACTICE,
    transaction: process.env.REACT_APP_API_ENDPOINT_TRANSACTION,
    paymentlink: process.env.REACT_APP_API_ENDPOINT_PAYMENTLINK,
    websocket: process.env.REACT_APP_API_ENDPOINT_WEBSOCKET,
    customers: process.env.REACT_APP_API_ENDPOINT_CUSTOMERS,
    payfabric: process.env.REACT_APP_API_ENDPOINT_PAYFABRIC,
    globalpay: process.env.REACT_APP_API_ENDPOINT_GLOBALPAY,
  },
  environment: process.env.REACT_APP_ENVIRONMENT_LABEL,
  sanityChecksEnabled: process.env.REACT_APP_SANITY_CHECKS_ENABLED === 'true',
  globalPayPayFieldsKey: process.env.REACT_APP_GLOBALPAY_PAYFIELDS_KEY,
  globalPayEnvironment: process.env.REACT_APP_GLOBALPAY_ENVIRONMENT,
};

export default Env;
